<template>
	<a
		class="notification-item dropdown-item"
		:class="[{ 'unread': !item.seen }, { 'empty': isEmpty }]"
		:href="link"
		@click="go">
		<div class="notification__icon">
			<div
				class="notification-icon"
				:class="`notification-icon-${ iconClass(item.type) }`">
				<i class="material-icons" v-if="isNewOrder || isNewWholesaleOrder">add_shopping_cart</i>
				<i v-if="isWholesaleAsDelivered" class="material-icons">shopping_cart_checkout</i>
				<i v-if="isWholesaleAsDelivery" class="material-icons">local_shipping</i>
				<i v-if="isWholesaleProcessing" class="material-icons">hourglass_empty</i>
				<icon name="dollar-sign" scale=".8" v-if="isNewPayment"></icon>
				<icon name="brands/facebook-f" scale=".8" v-if="isFBToken"></icon>
				<icon name="money-bill-alt" scale=".8" v-if="isPaymentConfirmation"></icon>
				<i class="material-icons" v-if="isOrderLimit">remove_shopping_cart</i>
				<i class="material-icons" v-if="isOrderProcessed">unarchive</i>
				<i class="material-icons" v-if="isEmpty">notifications</i>
				<i class="material-icons" v-if="isContactReminder">date_range</i>
				<i class="material-icons" v-if="item.type === 'new_wallet_history' || item.type === 'wallet_history_update'">account_balance_wallet</i>
				<i class="material-icons" v-if="item.type === 'new_billing'">notifications</i>
				<i class="material-icons" v-if="item.type === 'new_withdrawal'">account_balance</i>
				<icon name="dollar-sign" scale=".8" v-if="item.type === 'billing_payment'"></icon>
				<i class="material-icons" v-if="item.type === 'new_logistic' || item.type === 'logistic_update'">local_shipping</i>
				<i class="material-icons" v-if="item.type === 'logistic' && !item.data.is_solved && !item.data.category">local_shipping</i>
				<i class="material-icons" v-if="item.type === 'logistic' && item.data.is_solved && !item.data.category">done</i>
				<i class="material-icons" v-if="isPickupSupport">support</i>
				<i class="material-icons text-danger" v-if="isProductSuspended">block</i>
				<i class="material-icons text-white" v-if="isProductIcon || isProductStatus">inventory_2</i>
				<i class="fab fa-whatsapp text-white" v-if="isWhatsappFailed"></i>
				<i class="material-icons text-white" v-if="isNewDropshipper || isNewSupplier">person</i>
			</div>
		</div>
		<div class="notification__content">
			<div class="notification__content__top">
				<div class="notification__type">{{ type }}</div>
				<div class="notification__time" v-tooltip="timeDetails">{{ time }}</div>
			</div>
			<div class="notification__message" v-html="this.sanitizeHtml(message)"></div>
		</div>
	</a>
</template>

<script>
import { mapActions } from 'vuex';
import { getNotifMessage, sanitizeHtml } from '@/lib/helper';
import { NOTIFICATION_TYPES, NOTIFICATION_TYPES_CLASS } from '@/lib/statics';

const notifTypesClass = NOTIFICATION_TYPES_CLASS;

export default {
	name: 'notification',
	data() {
		return {
		};
	},
	props: {
		item: {
			type: Object,
		},
	},
	methods: {
		...mapActions({
			markAsRead: 'notifications/markAsRead',
		}),
		go(event) {
			event.preventDefault();

			const ids = [this.item._id];
			const params = {
				ids,
			};
			this.markAsRead(params);

			this.$emit('click');
			console.log('Logistic Notification Click');

			this.$router.push(this.link);

			// if (this.isNewOrder || this.isNewPayment || this.isOrderProcessed) {
			// 	const orderId = this.item.data.submission_id.$oid;
			// 	this.$router.push({ name: 'submissionDetails', params: { id: orderId } });
			// } else if (this.isFBToken) {
			// 	this.$router.push('/settings/customer-file');
			// } else if (this.isOrderLimit) {
			// 	this.$router.push('/plans');
			// } else if (this.isPaymentConfirmation) {
			// 	this.$router.push('/payments');
			// } else if (this.isContactReminder) {
			// 	this.$router.push('/contacts/reminder');
			// } else if (this.item.type === 'new_billing') {
			// 	this.$router.push('/billings');
			// } else if (this.item.type === NOTIFICATION_TYPES.WITHDRAWAL_NEW) {
			// 	this.$router.push('/admin/withdrawals');
			// } else if (this.item.type === NOTIFICATION_TYPES.BILLING_PAYMENT) {
			// 	this.$router.push('/admin/billings');
			// }
		},
		iconClass(type) {
			let theType = type;
			if (type === 'logistic') {
				// eslint-disable-next-line camelcase
				const isSolved = this?.item?.data?.is_solved ?? false;
				if (isSolved) {
					theType = 'success';
				} else {
					theType = 'warning';
				}
			} else if (this.isProductStatus && this.isProductStatusLive) {
				theType = 'success';
			} else if (this.isWholesaleAsDelivered) {
				theType = 'success';
			} else {
				theType = notifTypesClass[theType];
			}
			return theType;
		},
		sanitizeHtml,
	},
	computed: {
		isNewOrder() {
			return this.item.type === 'new_order';
		},
		isNewWholesaleOrder() {
			return this.item.type === 'new_wholesale_order';
		},
		isWholesaleAsDelivered() {
			return this.item.type === 'wholesale_mark_as_delivered';
		},
		isWholesaleProcessing() {
			return this.item.type === 'wholesale_process';
		},
		isWholesaleAsDelivery() {
			return this.item.type === 'wholesale_mark_as_delivery';
		},
		isNewPayment() {
			return this.item.type === 'new_payment';
		},
		isFBToken() {
			return this.item.type === 'fb_token_expired';
		},
		isOrderLimit() {
			return this.item.type === 'order_limit';
		},
		isPaymentConfirmation() {
			return this.item.type === 'new_payment_confirmation';
		},
		isOrderProcessed() {
			return this.item.type === 'order_processed';
		},
		isEmpty() {
			return this.item.type === 'empty';
		},
		isContactReminder() {
			return this.item.type === 'contact_reminder';
		},
		isProductSuspended() {
			return this.item.type === 'product_suspended';
		},
		isProductRequested() {
			return this.item.type === 'product_requested';
		},
		isProductPricing() {
			return this.item.type === 'product_pricing';
		},
		isProductUpdated() {
			return this.item.type === 'product_updated';
		},
		isProductImported() {
			return this.item.type === 'product_imported';
		},
		isProductInvitation() {
			return this.item.type === 'product_invitation';
		},
		isProductInvitationDistributor() {
			return this.item.type === 'product_invitation_distributor';
		},
		isProductStock() {
			return this.item.type === 'product_stock';
		},
		isWhatsappFailed() {
			return this.item.type === 'whatsapp_failed';
		},
		isNewDropshipper() {
			return this.item.type === 'new_dropshipper';
		},
		isNewSupplier() {
			return this.item.type === 'new_supplier';
		},
		type() {
			let typeLabel = '';
			const type = this.item.type;
			if (this.isNewOrder) {
				typeLabel = 'Pesanan Baru';
			} else if (this.isNewWholesaleOrder) {
				typeLabel = 'Pesanan Wholesale Order Baru';
			} else if (this.isWholesaleAsDelivered) {
				typeLabel = 'Pesanan Wholesale Order Sudah diterima';
			} else if (this.isWholesaleProcessing) {
				typeLabel = 'Pembayaran Wholesale Order Sudah diterima';
			} else if (this.isWholesaleAsDelivery) {
				typeLabel = 'Pesanan Wholesale Order telah dikirim';
			} else if (this.isNewPayment) {
				typeLabel = 'Pembayaran';
			} else if (this.isOrderProcessed) {
				typeLabel = 'Pesanan Telah Diproses';
			} else if (this.isPaymentConfirmation) {
				typeLabel = 'Konfirmasi Pembayaran';
			} else if (this.isFBToken) {
				typeLabel = 'Integrasi Facebook';
			} else if (this.isOrderLimit) {
				typeLabel = 'Order Limit';
			} else if (this.isContactReminder) {
				typeLabel = 'Pengingat Kontak';
			} else if (type === 'empty') {
				typeLabel = 'Notifikasi';
			} else if (type === 'new_billing') {
				typeLabel = 'Tagihan Baru';
			} else if (type === 'new_wallet_history') {
				typeLabel = 'Transaksi Baru';
			} else if (type === 'wallet_history_update') {
				typeLabel = 'Update Transaksi';
			} else if (type === 'new_withdrawal') {
				typeLabel = 'Withdrawal Request';
			} else if (type === NOTIFICATION_TYPES.BILLING_PAYMENT) {
				typeLabel = 'Pembayaran Billing';
			} else if (type === NOTIFICATION_TYPES.NEW_LOGISTIC) {
				typeLabel = 'Status Pengiriman';
			} else if (type === NOTIFICATION_TYPES.LOGISTIC) {
				// eslint-disable-next-line camelcase
				const orderId = this?.item?.data?.order_id ?? '';
				typeLabel = `Pengiriman #${orderId}`;

				if (this.isPickupSupport) {
					// eslint-disable-next-line camelcase
					const shippingId = this?.item?.data?.shipping_id ?? '';
					typeLabel = `Pickup Support Shipping ID ${shippingId}`;
				}
			} else if (this.isProductSuspended) {
				typeLabel = 'Produk Ditangguhkan';
			} else if (this.isProductRequested || this.isProductUpdated) {
				typeLabel = 'Produk Perlu Ditinjau';
			} else if (this.isProductPricing) {
				typeLabel = 'Produk Baru Perlu Ditinjau';
			} else if (this.isProductImported) {
				typeLabel = 'Produk Baru Diimport';
			} else if (this.isProductInvitation) {
				typeLabel = 'Undangan Penjualan Produk';
			} else if (this.isProductInvitationDistributor) {
				typeLabel = 'Undangan Produk Wholesale';
			} else if (this.isProductStock) {
				typeLabel = 'Stok Produk Menipis';
			} else if (this.isProductStatus) {
				typeLabel = this.isProductStatusLive ? 'Produk Aktif Kembali' : 'Produk Perlu Ditinjau';
			} else if (this.isWhatsappFailed) {
				const whatsappData = this?.item?.data;
				typeLabel = whatsappData?.message || 'WhatsApp Failed';
			} else if (this.isNewDropshipper || this.isNewSupplier) {
				const type = this.isNewDropshipper ? 'Seller' : 'Supplier';
				typeLabel = `New ${type} Registered`;
			} else {
				typeLabel = 'Notifikasi';
			}
			return typeLabel;
		},
		date() {
			const createdAt = this.item.created_at;
			const timezone = this.user ? this.user.timezone : 'Asia/Jakarta';
			const date = this.moment.utc(createdAt, 'YYYY-MM-DD HH:mm:ss').tz(timezone);
			return date;
		},
		time() {
			const relativeTime = this.date.fromNow();
			const time = !this.isEmpty ? relativeTime : '';
			return time;
		},
		message() {
			const message = getNotifMessage(this.item);
			return message;
		},
		timeDetails() {
			const time = this.date.format('DD MMMM YYYY, HH:mm');
			return time;
		},
		link() {
			let path = '#';
			let productId = this.item?.data?.product_id;
			if (this.isNewOrder || this.isNewPayment || this.isOrderProcessed) {
				const submissionId = this.item.data.submission_id.$oid;
				// this.$router.push({ name: 'submissionDetails', params: { id: submissionId } });
				path = `/orders/${submissionId}`;
			} else if (this.isNewWholesaleOrder || this.isWholesaleAsDelivery || this.isWholesaleAsDelivered || this.isWholesaleProcessing) {
				const redirectUrl = this.item?.data?.redirect_url ?? '/admin/wholesale-order';
				path = redirectUrl; // Optional : filter to current wholesale order id
			} else if (this.isFBToken) {
				path = '/settings/customer-file';
			} else if (this.isOrderLimit) {
				path = '/plans';
			} else if (this.isPaymentConfirmation) {
				path = '/admin/billings';
			} else if (this.isContactReminder) {
				path = '/contacts/reminder';
			} else if (this.item.type === 'new_billing') {
				path = '/billings';
			} else if (this.item.type === NOTIFICATION_TYPES.WITHDRAWAL_NEW) {
				path = '/admin/withdrawals';
			} else if (this.item.type === NOTIFICATION_TYPES.BILLING_PAYMENT) {
				path = '/admin/billings';
			} else if (this.item.type === NOTIFICATION_TYPES.LOGISTIC) {
				const receiptNumber = this.item.data.receipt_number;
				path = `/logistics/monitoring?q=${receiptNumber}`;
				// eslint-disable-next-line camelcase
				const isSolved = this?.item?.data?.is_solved ?? false;
				if (isSolved) {
					path = `${path}&is_solved=true`;
				}

				if (this.isPickupSupport) {
					// eslint-disable-next-line camelcase
					const shippingId = this?.item?.data?.shipping_id ?? '';
					path = `/admin/pickup-supports?q=${shippingId}`;
				}
			} else if (this.isProductSuspended) {
				productId = this.item.data.product_id;
				path = `/products/${productId}/edit`;
			} else if (this.isProductPricing || this.isProductImported) {
				productId = this.item?.data?.product_id;
				if (productId && Array.isArray(productId)) {
					const implodeProductId = productId.join(',');
					path = `/admin/products?product_id=${implodeProductId}`;
				} else {
					path = `/admin/products?product_id=${productId}`;
				}
			} else if (this.isProductRequested) {
				path = '/admin/products';
			} else if (this.isProductUpdated) {
				path = `/admin/products?product_id=${productId}`;
			} else if (this.isNewDropshipper) {
				path = `/admin/user/seller?verification=approved&user_id=${this.item?.data?.user_id}`;
			} else if (this.isNewSupplier) {
				path = `/admin/supplier?status=requested&user_id=${this.item?.data?.user_id}`;
			} else if (this.isProductInvitation || this.isProductInvitationDistributor) {
				const productUrl = this?.item?.data?.product_url ?? '';
				if (productUrl) {
					path = productUrl;
				}
			} else if (this.isProductStock) {
				path = `/admin/ticket?ticket_id=${this.item?.data?.ticket_id}`;
			} else if (this.isProductStatus) {
				const routeProducts = '/products';
				path = this.isProductStatusLive
					? `${routeProducts}?status=live`
					: routeProducts;
			}
			return path;
		},
		isPickupSupport() {
			return this.item.type === 'logistic' && this.item.data.category === 'pickup_support';
		},
		isProductIcon() {
			return this.isProductRequested
				|| this.isProductPricing
				|| this.isProductUpdated
				|| this.isProductImported
				|| this.isProductInvitation
				|| this.isProductInvitationDistributor
				|| this.isProductStock;
		},
		isProductStatus() {
			return this.item?.type === 'product_status';
		},
		isProductStatusLive() {
			return this.item?.data?.status === 'live';
		},
	},
};
</script>

<style lang="scss">
$icon_height: 25px;

$color__primary: #0098DA;
$color__order: #FFCC29;
$color__warning: #f3c11e;
$color__orange: #f3771e;
$color__requested: $color__warning;
$color__pricing: $color__primary;
$color__updated: $color__warning;
$color__reminder: #f06277;
// $color__payment: #ffcc29;
$color__payment: #8AB94B;
$color__success: #8AB94B;
$color__payment-confirmation: #75CFD8;
$color__facebook: #395A9A;
$color__limit: #ED3237;
$color__failed: $color__limit;
$color__empty: #CED5D9;
$color__stock: #dc00a1;

.notification-item {
	display: flex !important;
	padding: 1.1em 1em;
	width: 100%;
	border-bottom: 1px solid #ddd !important;
	cursor: pointer;

	&.dropdown-item {
		padding: 1.5rem 1rem !important;
		color: #656565;
	}

	&.dropdown-item:hover {
		color: $dark_color !important;
		background-color: #f6fff8 !important;
		&.unread {
			background-color: #f6fff8 !important;
		}
	}

	@media (min-width: 576px) {
		min-width: 400px;
	}

	&:active {
		color: inherit;
	}

	&:last-child {
		border-bottom: 0;
	}

	&.unread {
		// background-color: #e7fbfd;
		background-color: $highlight_color;
	}

	&.empty {
		pointer-events: none;
	}
}
.notification-item:hover > .notification__content > .notification__content__top > .notification__type,
.notification-item:focus > .notification__content > .notification__content__top > .notification__type,
.notification-item:active > .notification__content > .notification__content__top > .notification__type {
	color: #daeeff !important;
	.fi, .material-icons {
		color: #fff;
	}
}


.notification {
	&__icon {
		padding-top: 10px;
		padding-right: 20px;
		min-width: 35px;
	}

	&__content {
		width: 100%;
		// max-width: 239px;

		&__top {
			display: flex;
			justify-content: space-between;
		}
	}

	&__type {
		min-width: 100px;
		font-weight: bold;
		color: $primary_color;
	}

	&__time {
		opacity: .6;
	}

	&__message {
		margin-top: .5em;
		white-space: normal;
	}
}

.notification-icon {
	width: $icon_height;
	height: $icon_height;
	text-align: center;
	border-radius: 50%;
	background-color: #ddd;

	.material-icons,
	.fa-icon {
		height: $icon_height;
		color: #fff;
	}

	.material-icons, .fab {
		font-size: 1em;
		line-height: $icon_height;
	}

	&-order {
		background-color: $color__order;

		&-wholesale {
			background-color: $color__orange;
		}

		.fa-icon {
			position: relative;
			left: -1px;
		}
	}

	&-new-wallet-history,
	&-payment {
		background-color: $color__payment;
	}

	&-payment-confirmation {
		background-color: $color__payment-confirmation;
	}

	&-facebook {
		background-color: $color__facebook;
	}

	&-limit {
		background-color: $color__limit;
	}

	&-order-processed {
		background-color: $color__facebook;
	}

	&-contact-reminder {
		background-color: $color__reminder;
	}

	&-new-billing {
		background-color: $color__primary;
	}

	&-empty {
		background-color: $color__empty;
	}

	&-success {
		background-color: $color__success;
	}

	&-failed {
		background-color: $color__failed;
	}

	&-warning {
		background-color: $color__warning;
	}

	&-requested {
		background-color: $color__requested;
	}

	&-pricing {
		background-color: $color__pricing;
	}

	&-updated {
		background-color: $color__updated;
	}

	&-imported {
		background-color: $color__success;
	}

	&-dropshipper {
		background-color: $color__primary;
	}

	&-supplier {
		background-color: $color__success;
	}

	&-invitation {
		background-color: $color__success;
	}

	&-stock {
		background-color: $color__stock;
	}

	&-product-status {
		background-color: $color__reminder;
	}

	&-order-wholesale-delivery {
		background-color: $color__primary;
	}
}
</style>
